import { getUserDetails } from "utils/localStorageServices";
import moment from "moment";

export const validateToken = () => {
  const tokenObject = getUserDetails();
  const tokenExpiry = tokenObject?.expiresIn;
  const token = tokenObject?.token;
  return !(!tokenObject || !token || moment(tokenExpiry).isBefore(moment()));
};
